const initialState = {
  activeOrdersInitLoad: false,
  activeOrders: [],
  seenOrders: [],
  unseenOrderCount: 0,
  lastUpdated: new Date(),
  tutorialOrders: [
    {
      _id: "tutorial-order",
      tutorial: true,
      order_number: "TUT-0001",
      easy_id: "tutorial-order",
      direct: true,
      order_date: new Date(),
      customer: {
        email: "tutorial@saucey.com",
        first_name: "John",
        last_name: "Appleton",
        birthday: "1990-01-01",
        verification_status: "PASSED",
      },
      fraud_eval: {
        score: 0,
        fraud_level: "green",
        decision: "approve",
        violations: [
          
        ],
      },
      order_type: "delivery",
      products: [
        {
          image:
            "https://cdn.saucey.com/direct/web/tutorial/lime.jpg",
          title: "A tutorial Lime,",
          sku_id: "tutorial-lime",
          company: "Saucey",
          volume: "Each",
          volume_label: "Each",
          price: 3.32,
          quantity: 2,
        },
      ],
      line_items: [
        {
          index: 0,
          title: "Subtotal",
          display: "$6.64",
          value: 6.64,
        },
        {
          index: 1,
          title: "Delivery Fee",
          display: "$4.99",
          format: "DELIVERY_FEE",
          value: 4.99,
        },
        {
          index: 2,
          title: "Taxes",
          display: "$0.64",
          value: 0.64,
        },
        {
          index: 3,
          title: "Promo Code",
          display: "ADD",
          format: "PROMO",
        },
        {
          index: 4,
          title: "Tip",
          display: "$1",
          value: 1,
        },
        {
          index: 5,
          title: "Total Charged to Customer",
          display: "$13.27",
          value: 13.27,
          bold: true,
        },
      ],
      payment_card_last_4: "4242",
      payment_card_brand: "visa",
      total: 45.11,
      order_status: 0,
    }
  ],
};

const ordersReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_LAST_UPDATED":
      return {
        ...state,
        lastUpdated: new Date(),
      };
    case "LOAD_ACTIVE_ORDERS":
      return {
        ...state,
        activeOrders: action.payload,
      };
    case "ADD_SEEN_ORDERS":
      return {
        ...state,
        seenOrders: [...state.seenOrders, ...action.payload],
      };
    case "TUTORIAL_PRODUCT_UPDATE":
      return {
        ...state,
        tutorialOrders: state.tutorialOrders.map((order) => {
          if (order._id === action.payload.order_id) {
            return action.payload.order;
          }
          return order;
        }),
      };
    case "ACCEPT_TUTORIAL_ORDER":
      return {
        ...state,
        tutorialOrders: state.tutorialOrders.map((order) => {
          if (order._id === action.payload) {
            return { ...order, order_status: 1 };
          }
          return order;
        }),
      };
    case "SET_ACTIVE_ORDERS_INIT_LOAD":
      return {
        ...state,
        activeOrdersInitLoad: action.payload,
      };
    case "ADD_UNSEEN_ORDER_COUNT":
      return {
        ...state,
        unseenOrderCount: state.unseenOrderCount + action.payload,
      };
    case "RESET_UNSEEN_ORDER_COUNT":
      return {
        ...state,
        unseenOrderCount: 0,
      };
    default:
      return state;
  }
};

export default ordersReducer;
